export default __webpack_public_path__ + "static/media/arrowdowndrop.177227f8.svg";